import { render } from "./AppActionButton.vue?vue&type=template&id=8a660e12&scoped=true"
import script from "./AppActionButton.vue?vue&type=script&lang=js"
export * from "./AppActionButton.vue?vue&type=script&lang=js"

import "./AppActionButton.vue?vue&type=style&index=0&id=8a660e12&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a660e12"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
